// context/FormDataContext.tsx
import React, { createContext, useContext, useState } from "react";

type FormData = {
  [key: string]: any;
};

interface FormDataContextProps {
  formData: FormData;
  setFormValue: (field: string, value: any) => void;
}

const FormDataContext = createContext<FormDataContextProps | null>(null);

export const useFormData = () => {
  const context = useContext(FormDataContext);
  if (!context) throw new Error("useFormData must be used within provider");
  return context;
};

export const FormDataProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [formData, setFormData] = useState<FormData>({});

  const setFormValue = (field: string, value: any) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  return (
    <FormDataContext.Provider value={{ formData, setFormValue }}>
      {children}
    </FormDataContext.Provider>
  );
};
